import React from "react";
import { Icon } from "@iconify/react";
import SectionTitle from "../SectionTitle/SectionTitle";
import Services from "../../api/Services";



const ServiceSection = (props) => {

    const { SectionTitleShow = true, } = props

    return (
        <div className={"" + props.hclass} style={props.style}>
            <div className="container">
                {SectionTitleShow && (
                    <div className="row">
                        <SectionTitle subtitle={'Nos Services'} title={"Solutions d'excellence en"} titleColor={'Aluminium'} />
                    </div>
                )}
                <div className="row align-items-center">
                    {Services.slice(0, 6).map((service, item) => (
                        <div className="col-lg-4 col-md-6 col-12" key={item}>
                            <div className="wpo-service-item ">
                                <div className="icon">
                                    <i><Icon icon={service.icon} className="service-tabler-icon" aria-hidden="true" /></i>
                                </div>
                                <h2><span>{service.title}</span></h2>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>


    );
}

export default ServiceSection;


